import { MarkdownToJSX } from 'markdown-to-jsx'

import { HorizontalRuler } from '../components/HorizontalRuler'

import { Mark } from '../components/Mark'
import { Table } from '../components/Table'
import { MarkdownConfigurationInput } from '../configuration'

export const htmlComponents = ({ isLiveContent, isReference, messageId }: MarkdownConfigurationInput) =>
  ({
    a: {
      component: 'a',
      props: {
        className: 'kui-link',
      },
    },
    blockquote: {
      component: 'blockquote',
      props: {
        className: 'border-l-2 border-subdued pl-4 italic m-2',
      },
    },
    code: {
      component: 'code',
      props: {
        className: 'bg-subdued text-primary text-sm rounded-md px-1',
      },
    },
    details: {
      component: 'details',
      props: {
        className: 'border-l border-r border-b border-default px-4 first-of-type:mt-4 first-of-type:border-t first-of-type:rounded-t-lg last-of-type:rounded-b-lg',
      },
    },
    hr: {
      component: HorizontalRuler,
    },
    img: {
      component: 'img',
      props: {
        className: 'rounded-md',
      },
    },
    pre: {
      component: 'pre',
      props: {
        className:
          'bg-subdued text-primary text-sm rounded-md overflow-auto p-2 my-2',
      },
    },
    RiskIndicator: {
      component: 'div',
    },
    table: {
      component: Table,
      props: {
        isPreviewDisabled: isLiveContent,
        isPreviewHidden: isReference,
        messageId,
      },
    },
    mark: {
      component: Mark,
    },
  } satisfies MarkdownToJSX.Overrides)
